var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseLayout',[_c('div',{staticClass:"inner w-full"},[_vm._t("default")],2),_c('Footer',{staticClass:"mt-s48"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }